module.exports = __webpack_public_path__ + "static/template-about-hero-background-bca44d27c153ce97ab01177c38cf17c2.jpg";